import { FC } from "react";
import { FeedbackSource } from "../../interfaces/endpoints/ICustomerFeedback";
import {
  SOURCE_BADGE_CLASSES,
  SOURCE_LABELS
} from "../../utils/customerFeedback/labels";

interface SourceBadgeProps {
  source: FeedbackSource;
}

// Small pill identifying which surface the feedback came from. The
// color set is defined alongside the label map so the legend stays
// in sync — see utils/customerFeedback/labels.ts.
const SourceBadge: FC<SourceBadgeProps> = ({ source }) => {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium
        ${SOURCE_BADGE_CLASSES[source]}`}
    >
      {SOURCE_LABELS[source]}
    </span>
  );
};

export default SourceBadge;
